var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-upload',{ref:"upload",attrs:{"action":"","auto-upload":true,"file-list":_vm.fileList,"http-request":_vm.customRequest,"multiple":true}},[_c('el-button',{attrs:{"size":"small","type":"primary"}},[_vm._v("点击选取附件进行上传")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }